import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetLaundryBranchesQueryParams, IGetLaundryBranchesRes } from "types/laundry"

import laundriesService from "api/laundriesService"

const useGetLaundryBranches = (query: IGetLaundryBranchesQueryParams, enabled: boolean) => {
  return useQuery(["laundry_branches", {...query}], async () => {
    try {
      const res: AxiosResponse<IGetLaundryBranchesRes> = await laundriesService.getLaundryBranches(query)

      return res.data
    }  catch (err: any) {
      return err.response
    }
  }, { enabled, refetchOnWindowFocus: false })
}

export default useGetLaundryBranches